import { HiOutlineDownload } from "react-icons/hi";
import { FaWhatsapp } from "react-icons/fa";
import { MdHeadsetMic } from "react-icons/md";
import {
  PHONE_NUMBERS,
  getCallUrl,
  getWhatsAppUrl,
} from "@/utils/contactNumbers";
import styles from "./HolidayDetail.module.css";
import { IoLogoWhatsapp } from "react-icons/io";

export default function HolidayActionCards({
  isIndia = true,
  packageName = "",
  showDownload = true,
  showAgent = true,
  onDownloadClick,
  className = "",
}) {
  const phone = isIndia ? PHONE_NUMBERS.india : PHONE_NUMBERS.uae;
  const whatsappMessage = packageName
    ? `Hi, I am interested in ${packageName}`
    : "Hi, I am interested in this holiday package";

  const items = [
    ...(showDownload
      ? [
        {
          key: "download",
          label: "Download Itinerary",
          icon: <HiOutlineDownload size={22} color="#424753" />,
          iconClass: styles.mediaIconNeutral,
          onClick: onDownloadClick,
        },
      ]
      : []),
    {
      key: "whatsapp",
      label: "Enquire via WhatsApp",
      icon: <IoLogoWhatsapp size={24} color="#25D366" />,
      iconClass: styles.mediaIconNeutral,
      onClick: () => {
        window.open(getWhatsAppUrl(phone.whatsapp, whatsappMessage), "_blank", "noopener,noreferrer");
      },
    },
    ...(showAgent
      ? [
        {
          key: "agent",
          label: "Talk to our Agent",
          icon: <MdHeadsetMic size={22} color="#424753" />,
          iconClass: styles.mediaIconNeutral,
          onClick: () => {
            window.location.href = getCallUrl(phone.call);
          },
        },
      ]
      : []),
  ];

  return (
    <div className={`${styles.mediaCardRow} ${className}`.trim()}>
      {items.map((item) => (
        <button
          key={item.key}
          type="button"
          className={styles.mediaCard}
          onClick={item.onClick}
        >
          <span className={`${styles.mediaIconCircle} ${item.iconClass}`}>
            {item.icon}
          </span>
          <span className={styles.mediaText}>{item.label}</span>
        </button>
      ))}
    </div>
  );
}
